import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Globals } from '../../globals';


@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private http: Http, private global: Globals) { }
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.global.checkLogin().map(res => {
            if (!res) {
                this.router.navigate(['/login']);
            }
            return res;
        });
    }
}



// WEBPACK FOOTER //
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/app/services/auth/auth.guard.ts